import { BASE_NETWORK } from '../config';

export const switchToBaseNetwork = async () => {
  try {
    await window.ethereum.request({
      method: 'wallet_switchEthereumChain',
      params: [{ chainId: BASE_NETWORK.chainId }],
    });
  } catch (switchError) {
    if (switchError.code === 4902) {
      try {
        await window.ethereum.request({
          method: 'wallet_addEthereumChain',
          params: [BASE_NETWORK],
        });
      } catch (addError) {
        console.error('Error adding Base network:', addError);
      }
    } else {
      console.error('Error switching to Base network:', switchError);
    }
  }
};
